module.exports = __webpack_public_path__ + "static/img/090_TO8_1755.94e833e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/090_TO8_1755.jpg
// module id = 40Zb
// module chunks = 0